export default "__VITE_ASSET__B3Hw4fA1__"